<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button class="page-panel-header-control-button" size="mini" type="primary">预览</el-button>
        <el-button class="page-panel-header-control-button" size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="page-panel-header__title">图文资讯</div>
    </div>
    <div class="page-panel__body">
      <el-form ref="form" label-width="90px">
        <el-form-item label="新闻标题">
          <el-input v-model="newsParam.newsTitle" placeholder="请输入新闻标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="newsParam.newsSubtitle" placeholder="请输入新闻副标题"></el-input>
        </el-form-item>
        <el-form-item label="作者">
          <el-input v-model="newsParam.newsAuthor" placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item label="新闻分类">
          <el-radio-group v-model="newsParam.newsType">
            <el-radio v-for="item in commonJSON.newsType.options" :key="item.value" :label="item.value"
              v-show="item.enable">{{item.label}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="新闻封面">
          <img :src="newsParam.newsMainImg" alt="" v-if="newsParam.newsMainImg" @click="avatarEditorVisable=true"
            class="avartar_img">
          <el-button type="primary" @click="avatarEditorVisable=true" v-else>上传图片</el-button>
        </el-form-item>
        <el-form-item label="文章编辑">
          <ueditor :config="editorConfig" v-model="newsParam.newsText"></ueditor>
        </el-form-item>
        <el-form-item label="标签/关键字">
          <new-tag :dynamicTags='dynamicTags'></new-tag>
        </el-form-item>
      </el-form>
      <div class="article_footer_control">
        <el-button type="primary" @click="addNews">发布</el-button>
      </div>
    </div>
    <avatar-editor url="/file/upload" :width="150" :height="220" field="file" @crop-upload-success="uploadSuccess"
      :visible.sync="avatarEditorVisable"></avatar-editor>
  </div>
</template>
<script>
import avatarEditor from '@/common/component/avatarEditor';
import { sessionStorage } from '@/common/util/storage';
import * as newsApi from '@/api/industryIdynamics';
// import axios from 'axios';
const commonJSON = require('@/common/Json/index');
export default {
  data() {
    return {
      newsId: null,
      avatarEditorVisable: false,
      commonJSON,
      uploadUrl: {
        default: '/file/upload',
        type: 'string'
      },
      dialogVisible1: false,
      // 裁剪组件的基础配置option
      picsList: [],
      // 防止重复提交
      loading: false,
      newsClassification: sessionStorage.get('getdiclist2'),
      newsParam: {},
      dialogImageUrl: '',
      dialogVisible: false,
      dynamicTags: [],
      // 富文本框初始化
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      }
    };
  },
  components: {
    avatarEditor
  },
  methods: {
    uploadSuccess(response, file, fileList) {
      this.newsParam.newsMainImg = response.url;
      this.avatarEditorVisable = false;
    },
    changeUpload(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        return false;
      }
      this.fileinfo = file;
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = file.url;
        this.dialogVisible1 = true;
      });
    },
    addNews() {
      this.newsParam.newsTarget = this.dynamicTags.join(',');
      newsApi.addNews(this.newsParam).then(res => {
        this.$router.push({
          path: '/admin/industryIdynamics'
        });
      });
    },
    getNewsDetail() {
      newsApi.getNewsDetail({ newsId: this.newsId }).then(res => {
        this.newsParam = res.data;
        if (this.newsParam.newsTarget) {
          this.dynamicTags = this.newsParam.newsTarget.split(',');
        }
        this.newsParam.newsCategory = 0;
      });
    },
    back() {
      this.$router.push({
        path: '/admin/industryIdynamics'
      });
    },
    handleRemove(file) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  created() {
    this.newsId = this.$route.params.newsId;
    this.getNewsDetail();
  }
};
</script>
<style lang="stylus" scoped>
.cropper-content {
  .cropper {
    width auto
    height 300px
  }
}
.el-tag + .el-tag {
  margin-left 10px
}
.button-new-tag {
  margin-left 10px
  height 32px
  line-height 30px
  padding-top 0
  padding-bottom 0
}
.input-new-tag {
  width 90px
  margin-left 10px
  vertical-align bottom
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/industryIdynamics/edit.vue